// Balance Sheet and Related Data
// UPDATED: Now using REAL DATA from ABC Excel files
// Source: ABC_Balanco_Patrimonial.xlsx

// Import real financial data
import { 
  realBalanceSheetData,
  toMillionsUSD 
} from './realFinancialData';

// ============================================================================
// BALANCE SHEET DATA - FROM REAL DATA
// ============================================================================
export const balanceSheetData = {
  // 2024 ACTUAL - FROM REAL DATA
  2024: {
    // Assets
    totalAssets: toMillionsUSD(realBalanceSheetData[2024].totalActivo),  // 78.93 M USD
    fixedAssets: toMillionsUSD(realBalanceSheetData[2024].totalActivosNaoCorrentes),  // 0.00 M USD (Note: source shows 28 which appears to be placeholder)
    currentAssets: toMillionsUSD(realBalanceSheetData[2024].totalActivosCorrentes),  // 78.93 M USD
    intangibleAssets: toMillionsUSD(realBalanceSheetData[2024].imobilizacoesIncorporeas),  // 0
    tangibleAssets: toMillionsUSD(realBalanceSheetData[2024].imobilizacoesCorporeas),  // 0.00 M USD
    inventory: toMillionsUSD(realBalanceSheetData[2024].existencias),  // 0.33 M USD
    receivables: toMillionsUSD(realBalanceSheetData[2024].contasAReceber),  // 31.18 M USD
    cash: toMillionsUSD(realBalanceSheetData[2024].disponibilidades),  // 23.76 M USD
    otherCurrentAssets: toMillionsUSD(realBalanceSheetData[2024].outrosActivosCorrentes),  // 23.66 M USD
    // Liabilities & Equity
    totalEquity: toMillionsUSD(realBalanceSheetData[2024].totalCapitalProprio),  // 182.02 M USD
    shareCapital: toMillionsUSD(realBalanceSheetData[2024].capital),  // 16.45 M USD
    reserves: toMillionsUSD(realBalanceSheetData[2024].reservas),  // 1.37 M USD
    retainedEarnings: toMillionsUSD(realBalanceSheetData[2024].resultadosTransitados),  // 65.25 M USD
    netIncomeYear: toMillionsUSD(realBalanceSheetData[2024].resultadosExercicio),  // 96.42 M USD
    totalLiabilities: toMillionsUSD(realBalanceSheetData[2024].totalPassivoNaoCorrente + realBalanceSheetData[2024].totalPassivoCorrente),  // 120.32 M USD
    longTermDebt: toMillionsUSD(realBalanceSheetData[2024].emprestimosMedioLongoPrazo),  // 15.05 M USD
    shortTermDebt: toMillionsUSD(realBalanceSheetData[2024].emprestimosCurtoPrazo),  // 8.30 M USD
    suppliers: toMillionsUSD(realBalanceSheetData[2024].contasAPagar),  // 47.83 M USD
    otherLiabilities: toMillionsUSD(realBalanceSheetData[2024].outrosPassivosCorrentes),  // 16.35 M USD
    provisions: toMillionsUSD(realBalanceSheetData[2024].provisoesOutrosRiscosEncargos),  // 19.45 M USD
    // Ratios - CALCULATED
    financialAutonomy: (realBalanceSheetData[2024].totalCapitalProprio / realBalanceSheetData[2024].totalCapitalProprioEPassivo) * 100,  // 60.2%
    netWorkingCapital: toMillionsUSD(realBalanceSheetData[2024].totalActivosCorrentes - realBalanceSheetData[2024].totalPassivoCorrente),  // 6.45 M USD
    fixedAssetsWeight: (realBalanceSheetData[2024].totalActivosNaoCorrentes / realBalanceSheetData[2024].totalActivo) * 100,  // 0.0%
    debtToEquity: (realBalanceSheetData[2024].totalPassivoNaoCorrente + realBalanceSheetData[2024].totalPassivoCorrente) / realBalanceSheetData[2024].totalCapitalProprio,  // 0.66
    currentRatio: realBalanceSheetData[2024].totalActivosCorrentes / realBalanceSheetData[2024].totalPassivoCorrente,  // 1.09
  },
  // 2025 BUDGET - FROM REAL DATA
  2025: {
    // Assets
    totalAssets: toMillionsUSD(realBalanceSheetData[2025].totalActivo),  // 183.71 M USD
    fixedAssets: toMillionsUSD(realBalanceSheetData[2025].totalActivosNaoCorrentes),  // 104.12 M USD
    currentAssets: toMillionsUSD(realBalanceSheetData[2025].totalActivosCorrentes),  // 79.58 M USD
    intangibleAssets: toMillionsUSD(realBalanceSheetData[2025].imobilizacoesIncorporeas),  // 73.27 M USD
    tangibleAssets: toMillionsUSD(realBalanceSheetData[2025].imobilizacoesCorporeas),  // 30.85 M USD
    inventory: toMillionsUSD(realBalanceSheetData[2025].existencias),  // 1.02 M USD
    receivables: toMillionsUSD(realBalanceSheetData[2025].contasAReceber),  // 46.55 M USD
    cash: toMillionsUSD(realBalanceSheetData[2025].disponibilidades),  // 17.79 M USD
    otherCurrentAssets: toMillionsUSD(realBalanceSheetData[2025].outrosActivosCorrentes),  // 14.22 M USD
    // Liabilities & Equity
    totalEquity: toMillionsUSD(realBalanceSheetData[2025].totalCapitalProprio),  // 155.47 M USD
    shareCapital: toMillionsUSD(realBalanceSheetData[2025].capital),  // 13.09 M USD
    reserves: toMillionsUSD(realBalanceSheetData[2025].reservas),  // 1.84 M USD
    retainedEarnings: toMillionsUSD(realBalanceSheetData[2025].resultadosTransitados),  // 46.95 M USD
    netIncomeYear: toMillionsUSD(realBalanceSheetData[2025].resultadosExercicio),  // 93.50 M USD
    totalLiabilities: toMillionsUSD(realBalanceSheetData[2025].totalPassivoNaoCorrente + realBalanceSheetData[2025].totalPassivoCorrente),  // 118.92 M USD
    longTermDebt: toMillionsUSD(realBalanceSheetData[2025].emprestimosMedioLongoPrazo),  // 15.05 M USD
    shortTermDebt: toMillionsUSD(realBalanceSheetData[2025].emprestimosCurtoPrazo),  // 4.61 M USD
    suppliers: toMillionsUSD(realBalanceSheetData[2025].contasAPagar),  // 46.56 M USD
    otherLiabilities: toMillionsUSD(realBalanceSheetData[2025].outrosPassivosCorrentes),  // 21.18 M USD
    provisions: toMillionsUSD(realBalanceSheetData[2025].provisoesOutrosRiscosEncargos),  // 22.80 M USD
    // Ratios
    financialAutonomy: (realBalanceSheetData[2025].totalCapitalProprio / realBalanceSheetData[2025].totalCapitalProprioEPassivo) * 100,  // 56.7%
    netWorkingCapital: toMillionsUSD(realBalanceSheetData[2025].totalActivosCorrentes - realBalanceSheetData[2025].totalPassivoCorrente),  // 7.23 M USD
    fixedAssetsWeight: (realBalanceSheetData[2025].totalActivosNaoCorrentes / realBalanceSheetData[2025].totalActivo) * 100,  // 56.7%
    debtToEquity: (realBalanceSheetData[2025].totalPassivoNaoCorrente + realBalanceSheetData[2025].totalPassivoCorrente) / realBalanceSheetData[2025].totalCapitalProprio,  // 0.77
    currentRatio: realBalanceSheetData[2025].totalActivosCorrentes / realBalanceSheetData[2025].totalPassivoCorrente,  // 1.10
  },
  // 2026 MOCK DATA - Mock values for current year (real data not yet available)
  // Note: Orçamento 2026 uses REAL DATA from realBalanceSheetData[2026]
  // These mock values simulate variance from budget for demonstration
  2026: {
    // Assets - Mock values slightly different from budget
    totalAssets: 245.0,  // Mock: slightly above budget (243.57)
    fixedAssets: 120.0,  // Mock: slightly above budget (118.81)
    currentAssets: 125.0,  // Mock: slightly above budget (124.77)
    intangibleAssets: 74.0,  // Mock: slightly above budget (73.27)
    tangibleAssets: 46.0,  // Mock: slightly above budget (45.53)
    inventory: 7.5,  // Mock: slightly above budget (7.40)
    receivables: 82.0,  // Mock: slightly above budget (80.68)
    cash: 18.5,  // Mock: slightly below budget (19.14)
    otherCurrentAssets: 17.0,  // Mock: slightly below budget (17.56)
    // Liabilities & Equity - Mock values
    totalEquity: 195.0,  // Mock: slightly above budget (191.91)
    shareCapital: 10.7,  // Mock: close to budget (10.69)
    reserves: 1.9,  // Mock: close to budget (1.91)
    retainedEarnings: 50.0,  // Mock: slightly above budget (49.29)
    netIncomeYear: 132.0,  // Mock: slightly above budget (129.97)
    totalLiabilities: 50.0,  // Mock value
    longTermDebt: 14.5,  // Mock: slightly below budget (15.05)
    shortTermDebt: 11.8,  // Mock: close to budget (11.81)
    suppliers: 62.0,  // Mock: slightly below budget (63.97)
    otherLiabilities: 24.0,  // Mock: slightly below budget (25.18)
    provisions: 30.0,  // Mock: slightly below budget (31.51)
    // Ratios - Mock values
    financialAutonomy: 54.5,  // Mock: slightly above budget (53.9%)
    netWorkingCapital: 25.0,  // Mock: slightly above budget (23.81)
    fixedAssetsWeight: 49.0,  // Mock: close to budget (48.8%)
    debtToEquity: 0.84,  // Mock: slightly below budget (0.86)
    currentRatio: 1.25,  // Mock: slightly above budget (1.24)
  },
};

// ============================================================================
// INVESTED CAPITAL DATA - DERIVED FROM REAL DATA
// ============================================================================
export const investedCapitalData = {
  2024: {
    totalInvestedCapital: toMillionsUSD(realBalanceSheetData[2024].totalCapitalProprio + realBalanceSheetData[2024].emprestimosMedioLongoPrazo + realBalanceSheetData[2024].emprestimosCurtoPrazo),
    fixedAssets: toMillionsUSD(realBalanceSheetData[2024].totalActivosNaoCorrentes),
    workingCapitalNeed: toMillionsUSD(realBalanceSheetData[2024].existencias + realBalanceSheetData[2024].contasAReceber - realBalanceSheetData[2024].contasAPagar),
    cash: toMillionsUSD(-realBalanceSheetData[2024].disponibilidades),
    otherItems: toMillionsUSD(realBalanceSheetData[2024].outrosActivosCorrentes - realBalanceSheetData[2024].outrosPassivosCorrentes),
  },
  2025: {
    totalInvestedCapital: toMillionsUSD(realBalanceSheetData[2025].totalCapitalProprio + realBalanceSheetData[2025].emprestimosMedioLongoPrazo + realBalanceSheetData[2025].emprestimosCurtoPrazo),
    fixedAssets: toMillionsUSD(realBalanceSheetData[2025].totalActivosNaoCorrentes),
    workingCapitalNeed: toMillionsUSD(realBalanceSheetData[2025].existencias + realBalanceSheetData[2025].contasAReceber - realBalanceSheetData[2025].contasAPagar),
    cash: toMillionsUSD(-realBalanceSheetData[2025].disponibilidades),
    otherItems: toMillionsUSD(realBalanceSheetData[2025].outrosActivosCorrentes - realBalanceSheetData[2025].outrosPassivosCorrentes),
  },
  // 2026 MOCK - Mock values for invested capital
  2026: {
    totalInvestedCapital: 220.0,  // Mock
    fixedAssets: 120.0,  // Mock
    workingCapitalNeed: 25.0,  // Mock
    cash: -18.5,  // Mock
    otherItems: -7.0,  // Mock
  },
};

// ============================================================================
// WORKING CAPITAL DATA - DERIVED FROM REAL DATA
// ============================================================================
export const workingCapitalData = {
  2024: {
    receivables: toMillionsUSD(realBalanceSheetData[2024].contasAReceber),  // 31.18 M USD
    inventory: toMillionsUSD(realBalanceSheetData[2024].existencias),  // 0.33 M USD
    suppliers: toMillionsUSD(-realBalanceSheetData[2024].contasAPagar),  // -47.83 M USD
    netWorkingCapital: toMillionsUSD(realBalanceSheetData[2024].contasAReceber + realBalanceSheetData[2024].existencias - realBalanceSheetData[2024].contasAPagar),
    dso: 117, // Days Sales Outstanding - still mock (requires revenue timing data)
    dio: 67,  // Days Inventory Outstanding - still mock
    dpo: 64,  // Days Payables Outstanding - still mock
    ccc: 120, // Cash Conversion Cycle - still mock
  },
  2025: {
    receivables: toMillionsUSD(realBalanceSheetData[2025].contasAReceber),  // 46.55 M USD
    inventory: toMillionsUSD(realBalanceSheetData[2025].existencias),  // 1.02 M USD
    suppliers: toMillionsUSD(-realBalanceSheetData[2025].contasAPagar),  // -46.56 M USD
    netWorkingCapital: toMillionsUSD(realBalanceSheetData[2025].contasAReceber + realBalanceSheetData[2025].existencias - realBalanceSheetData[2025].contasAPagar),
    dso: 163, // Estimated: (Receivables / Annual Revenue) * 365
    dio: 19,  // Estimated
    dpo: 163, // Estimated
    ccc: 19,  // DSO + DIO - DPO
  },
  // 2026 MOCK - Mock values for working capital
  2026: {
    receivables: 82.0,  // Mock
    inventory: 7.5,  // Mock
    suppliers: -62.0,  // Mock
    netWorkingCapital: 24.1,  // Mock: (82 + 7.5 - 62 - 3.4)
    dso: 223, // Mock
    dio: 113, // Mock
    dpo: 177, // Mock
    ccc: 159, // Mock
  },
};
